<div class="d-flex justify-content-between align-items-center"
  style="border-bottom: 2px solid black;margin-bottom: 10px;">
  <h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">View Attachments</h2>
  <div class="d-flex align-items-center gap-3">
    <mat-icon (click)="downloadAttachment()" style="cursor: pointer;">get_app</mat-icon>
    <mat-icon (click)="closeDialog()" style="cursor: pointer;">close</mat-icon>
  </div>
</div>

<div contentContainer class="row">
  <div class="col-lg-4 col-sm-12 text-align-end" *ngIf="spinner">
    <div class="meeting-indicator">
      <mat-progress-spinner mode="indeterminate" [diameter]="20" *ngIf="spinner"
        bdColor="rgba(51,51,51,0.8)"></mat-progress-spinner>
    </div>
  </div>
  <!--<img *ngIf="type.includes('image')" [src]="collaboraUrl">-->
  <iframe id="myFrame" [src]="collaboraUrl" style="height: calc(100vh - 100px);"></iframe>
  <!-- <object *ngIf="type=='application/pdf'" [data]="pdfSrc" style="height: calc(100vh - 100px);">
    <p>Your browser does not support PDFs.
      <a [href]="pdfSrc" download>Download the PDF</a>.
    </p>
  </object> -->

</div>
